import { isEmpty } from '@ember/utils'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { NormalizedInterval } from 'date-fns'

export interface LexileGrowthResponse {
  lexile_growth_by_grade: {
    grades: {
      grade_position: number
      student_count: number
      from_lexile_growth: number
      to_lexile_growth: number
    }[]
    student_count: number
  }
}

export interface LexileGrowthByGradeReportData {
  grades: {
    grade_position: number
    from_lexile_growth: number
    to_lexile_growth: number
    student_count: number
  }[]
  student_count: number
}

export async function lexileGrowth(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex,
  statsScope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<LexileGrowthByGradeReportData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('lexile_growth_by_grade', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<LexileGrowthResponse>(url, query)
  if (!data) return null

  const {
    lexile_growth_by_grade: { grades, student_count },
  } = data

  if (grades.length === 0) return null

  const filteredLexileGrowth = grades
    .filter((grade) => grade.grade_position !== null)
    .sort((a, b) => a.grade_position - b.grade_position)

  return {
    grades: filteredLexileGrowth,
    student_count,
  }
}
